import { AlpineComponent } from 'alpinejs';

import {
  getLocalIsActive,
  updateLocalStorage,
  localStorageEvents
} from '../../javascripts/helpers/localstorage';

const classes = {
  active: 'watchlist-btn--active'
};

const WatchlistBtn = (): AlpineComponent => ({
  isActive: false,
  id: null,
  title: '',
  update() {
    updateLocalStorage(this.id, this.title, !this.isActive);
  },
  check() {
    if (this.isActive !== getLocalIsActive(this.id)) {
      this.toggle();
    }
  },
  toggle() {
    this.isActive = !this.isActive;

    if (this.isActive) {
      this.$root.classList.add(classes.active);
    } else {
      this.$root.classList.remove(classes.active);
    }
  },
  bindControlEvents() {
    this.$root.addEventListener('click', () => {
      this.update();
    });
  },
  listenToLocalStorageChanges() {
    window.addEventListener(localStorageEvents.updated, ((
      e: CustomEvent<{ id: string }>
    ) => {
      if (e.detail?.id === this.id) {
        this.toggle();
      }
    }) as EventListener);
  },
  init() {
    this.id = this.$root.dataset.jsWatchlistId;
    this.title = this.$root.dataset.jsWatchlistTitle;

    this.check();
    this.bindControlEvents();
    this.listenToLocalStorageChanges();
  }
});

export default WatchlistBtn;
